module.exports = __webpack_public_path__ + "static/img/bg-safeguard.a9434991.jpg";